export default __webpack_public_path__ + "assets/images/6264cdc13ffe26e685ed67f11dfa80b0.png";